import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import { API_PRODUCTS } from '../../../../consts'
import { to } from '../../../../utils/to'

export const deleteAlias = async (aliasId: number | string, productId: number | string) => {
  const request: AxiosRequestConfig = {
    url: `${API_PRODUCTS}/${productId}/aliases/${aliasId}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' },
    withCredentials: true,
  }

  return await to<AxiosResponse, AxiosError>(axios(request))
}
